/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeeTerritoriesListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: EmployeeTerritoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';

import myGlobals = require('../globals');
import { EmployeeTerritoriesData, EmployeeTerritoriesService } from './EmployeeTerritories.service';
import { EmployeeTerritoriesSearchComponent }  from './EmployeeTerritoriesSearch.component';

@Component({
	selector: 'my-EmployeeTerritories',
	template: require('./EmployeeTerritoriesList.component.html'),
	providers: [EmployeeTerritoriesService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class EmployeeTerritoriesListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	EmployeeTerritoriesList: EmployeeTerritoriesData[];
	newEmployeeTerritories: EmployeeTerritoriesData;
	selectedEmployeeTerritories: EmployeeTerritoriesData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(EmployeeTerritoriesSearchComponent) filterComponent: EmployeeTerritoriesSearchComponent;

	sortExpression: string = "EmployeeID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private EmployeeTerritoriesService: EmployeeTerritoriesService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newEmployeeTerritories = new EmployeeTerritoriesData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		//this.EmployeeTerritoriesService.getAll().subscribe(record => this.EmployeeTerritoriesList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getEmployeeTerritoriesByPaging();

		/*
		this.EmployeeTerritoriesList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getEmployeeTerritories() {
		this.EmployeeTerritoriesService.getAll()
			.subscribe(data => this.EmployeeTerritoriesList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on EmployeeTerritoriesSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getEmployeeTerritoriesByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getEmployeeTerritoriesByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getEmployeeTerritoriesByPaging();
	}
	
	// Get records by paging
	getEmployeeTerritoriesByPaging() {
		this.EmployeeTerritoriesService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.EmployeeTerritoriesList=data.EmployeeTerritoriesList;
				this.rowsCount=data.RowsCount;
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}

	// Adds new record
	addEmployeeTerritories() {
		this.EmployeeTerritoriesService.addEmployeeTerritoriesData(this.newEmployeeTerritories).subscribe(record => console.log(record));
		this.getEmployeeTerritories();
	}

	// Updates existing record
	updateEmployeeTerritories() {
		this.EmployeeTerritoriesService.updateEmployeeTerritoriesData(this.selectedEmployeeTerritories).subscribe(record => console.log(record));
		this.getEmployeeTerritories();
	}

	// Deletes record with specified id
	deleteEmployeeTerritories(id: string) {
		if (window.confirm('Are you sure you want to delete this EmployeeTerritories?') == true)
		{
			this.EmployeeTerritoriesService.deleteEmployeeTerritories(id)
			.subscribe(data => this.getEmployeeTerritories(),
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('EmployeeTerritories record deleted successfully...', 'Delete EmployeeTerritories');
					console.log('EmployeeTerritories record deleted successfully...'); 
				}
			);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getEmployeeTerritoriesByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getEmployeeTerritoriesByPaging();
		}
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getEmployeeTerritoriesByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getEmployeeTerritoriesByPaging();
	}

	// On Edit - Go to Edit page
	onSelect(item: EmployeeTerritoriesData) {
		this.router.navigate(['/EmployeeTerritories', item.EmployeeID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: EmployeeTerritoriesData) {
		this.router.navigate(['/EmployeeTerritories/Details', item.EmployeeID]);
	}

	// Set record as selected
	SelectEmployeeTerritories(item: EmployeeTerritoriesData) {
		this.selectedEmployeeTerritories = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/EmployeeTerritories/EmployeeTerritoriesList.component.ts